var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrdered = function SvgOrdered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A89A6",
    strokeWidth: 0.094,
    d: "M12.495 18.208a2.116 2.116 0 0 0-.856-1.424 2.21 2.21 0 0 0-3.032.417 2.118 2.118 0 0 0-.318.576.89.89 0 0 0 1.673.61v-.002a.361.361 0 0 1 .053-.09.42.42 0 0 1 .571-.073m1.909-.014-4.083 3.51 2.24-2.996.01-.013a.332.332 0 0 0 .07-.252.343.343 0 0 0-.146-.235m1.909-.014a2.1 2.1 0 0 1-.416 1.583l-1.117 1.494-.056.075m1.589-3.152-1.589 3.152m-.32-3.138-.027.038.028-.037Zm.32 3.138H11m-.094 0H11m0 0h.625a.89.89 0 0 1 0 1.781h-2.5a.891.891 0 0 1-.713-1.423L11 21.36ZM9.484 10.63v-.064l-.061.02a.891.891 0 0 1-.695-1.632l1.25-.625a.89.89 0 0 1 1.288.796v5a.89.89 0 1 1-1.782 0v-3.494ZM23.766 16a.89.89 0 0 1-.891.891h-7.813a.89.89 0 0 1 0-1.781h7.813a.89.89 0 0 1 .89.89Zm-.891-4.109h-7.813a.89.89 0 0 1 0-1.781h7.813a.89.89 0 0 1 0 1.781Zm-7.813 8.219h7.813a.89.89 0 0 1 0 1.781h-7.813a.89.89 0 0 1 0-1.781Z"
  })));
};
export default SvgOrdered;